import React from 'react';
import PropTypes from 'prop-types';
import DocumentTypePropertyGeneralDataContainer from './generalData/DocumentTypePropertyGeneralDataContainer';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import { useQuery } from 'hooks/apollo';
import { DOCUMENT_TYPE_PROPERTY_QUERY } from '../queries';
import DocumentTypePropertyStatesContainer from './states/DocumentTypePropertyStatesContainer';

const DocumentTypePropertyContainer = ({ documentTypeId, propertyId, onChangeDocumentTypePropertyTitle, onRedirect }) => {
  const { data, loading } = useQuery(DOCUMENT_TYPE_PROPERTY_QUERY, {
    variables: { documentTypeId, propertyId },
    skip: documentTypeId === undefined || documentTypeId === null || propertyId === undefined || propertyId === null
  });

  return (
    <React.Fragment>
      {loading ? (
        <Card>
          <FakeText lines={10} />
        </Card>
      ) : (
        <>
          <DocumentTypePropertyGeneralDataContainer
            documentTypeId={documentTypeId}
            propertyId={propertyId}
            data={data?.documentTypeProperty ?? {}}
            onChangeDocumentTypePropertyTitle={onChangeDocumentTypePropertyTitle}
            onRedirect={onRedirect}
          />
          {propertyId !== null && propertyId !== undefined && (
            <DocumentTypePropertyStatesContainer
              documentTypeId={documentTypeId}
              propertyId={propertyId}
              data={data && data.documentTypeProperty ? data.documentTypeProperty.states : []}
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};

DocumentTypePropertyContainer.propTypes = {
  documentTypeId: PropTypes.number,
  propertyId: PropTypes.number,
  onChangeDocumentTypePropertyTitle: PropTypes.func,
  onRedirect: PropTypes.func
};

export default DocumentTypePropertyContainer;
